module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_pet@2x-7581bfd08b3f3a03a8c2fbff347d552b.webp";